import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "table_my"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "气动马达型号", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "气动马达厂家", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "主板型号", -1);
const _hoisted_5 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "主板版本号", -1);
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "SIM卡1卡号", -1);
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "SIM卡1开卡时间", -1);
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "SIM卡2卡号", -1);
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "SIM卡2开卡时间", -1);
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "气瓶编号", -1);
const _hoisted_11 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "气瓶的年检期限", -1);
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "压力传感器编号", -1);
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "压力传感器量程范围", -1);
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "压力传感器量通信方式", -1);
const _hoisted_15 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "可燃气体传感器编号", -1);
const _hoisted_16 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "可燃气体传感器量程范围", -1);
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "可燃气体传感器量通信方式", -1);
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力传感器编号", -1);
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力传感器量程范围", -1);
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力传感器量通信方式", -1);
const _hoisted_21 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "液位压力传感器编号", -1);
const _hoisted_22 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "液位压力传感器量通信方式", -1);
const _hoisted_23 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "液位压力传感器量程范围", -1);
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力进传感器编号", -1);
const _hoisted_25 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力进传感器量程范围", -1);
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力进传感器量通信方式", -1);
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力出传感器编号", -1);
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力出传感器量通信方式", -1);
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "管线压力出传感器量程范围", -1);
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "气瓶传感器类型", -1);
const _hoisted_32 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "padding": "0 10px"
  }
};
const _hoisted_33 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "电池容量(mAh)", -1);
const _hoisted_35 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "padding": "0 10px"
  }
};
const _hoisted_36 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_37 = {
  style: {
    "font-size": "12px",
    "color": "#666",
    "margin-top": "4px"
  }
};
const _hoisted_38 = {
  key: 1
};
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", {
  class: "th"
}, "开关阀超时时间(秒)", -1);
const _hoisted_40 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "padding": "0 10px"
  }
};
const _hoisted_41 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", {
  class: "th",
  colspan: "2"
}, null, -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _directive_hasPermi = _resolveDirective("hasPermi");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_scrollbar, {
    style: {
      "height": "95%",
      "padding-right": "20px"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("table", _hoisted_1, [_createElementVNode("tr", null, [_hoisted_2, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.airMotor), 1), _hoisted_3, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.airManufacturer), 1)]), _createElementVNode("tr", null, [_hoisted_4, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.motherBorderModel), 1), _hoisted_5, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.motherBorderVersion), 1)]), _createElementVNode("tr", null, [_hoisted_6, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.sim1Num), 1), _hoisted_7, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.sim1OpenTime), 1)]), _createElementVNode("tr", null, [_hoisted_8, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.sim2Num), 1), _hoisted_9, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.sim2OpenTime), 1)]), _createElementVNode("tr", null, [_hoisted_10, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.cylinderNum), 1), _hoisted_11, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.cylinderEndTime), 1)]), _createElementVNode("tr", null, [_hoisted_12, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pressureSn), 1), _hoisted_13, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pressureSr), 1)]), _createElementVNode("tr", null, [_hoisted_14, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pressureScm), 1), _hoisted_15, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.combPressureSn), 1)]), _createElementVNode("tr", null, [_hoisted_16, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.combPressureSr), 1), _hoisted_17, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.combPressureScm), 1)]), _createElementVNode("tr", null, [_hoisted_18, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelinePressureSn), 1), _hoisted_19, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelinePressureSr), 1)]), _createElementVNode("tr", null, [_hoisted_20, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelinePressureScm), 1), _hoisted_21, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.liquidLevelPreSn), 1)]), _createElementVNode("tr", null, [_hoisted_22, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.liquidLevelPreScm), 1), _hoisted_23, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.liquidLevelPreSr), 1)]), _createElementVNode("tr", null, [_hoisted_24, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelineInPreSn), 1), _hoisted_25, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelineInPreSr), 1)]), _createElementVNode("tr", null, [_hoisted_26, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelineInPreScm), 1), _hoisted_27, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelineOutPreSn), 1)]), _createElementVNode("tr", null, [_hoisted_28, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelineOutPreScm), 1), _hoisted_29, _createElementVNode("td", null, _toDisplayString($setup.deviceInfo.pipelineOutPreSr), 1)]), $setup.deviceInfo.actType == 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [_hoisted_31, _createElementVNode("td", null, [_createElementVNode("div", _hoisted_32, [!$setup.editMode.cylinderSnType ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("span", _hoisted_33, _toDisplayString($setup.getCylinderSnTypeLabel($setup.editValues.cylinderSnType)), 1), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[0] || (_cache[0] = $event => $setup.toggleEdit('cylinderSnType'))
    }, {
      default: _withCtx(() => [_createTextVNode("编辑并下发")]),
      _: 1
    })), [[_directive_hasPermi, ['device:page:zlxf']]])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_el_select, {
      modelValue: $setup.editValues.cylinderSnType,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $setup.editValues.cylinderSnType = $event),
      placeholder: "请选择",
      style: {
        "flex": "1"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_option, {
        label: "压力传感器",
        value: "0"
      }), _createVNode(_component_el_option, {
        label: "宝鸡麦克",
        value: "1"
      })]),
      _: 1
    }, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[2] || (_cache[2] = $event => $setup.handleWrite('cylinderSnType')),
      loading: $setup.writeLoading.cylinderSnType
    }, {
      default: _withCtx(() => [_createTextVNode("下发")]),
      _: 1
    }, 8, ["loading"])), [[_directive_hasPermi, ['device:page:zlxf']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      size: "small",
      onClick: _cache[3] || (_cache[3] = $event => $setup.cancelEdit('cylinderSnType'))
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    })), [[_directive_hasPermi, ['device:page:zlxf']]])], 64))])]), _hoisted_34, _createElementVNode("td", null, [_createElementVNode("div", _hoisted_35, [!$setup.editMode.batCouValue ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", null, _toDisplayString($setup.editValues.batCouValue || '-'), 1), _createElementVNode("div", _hoisted_37, " 最新下发时间: " + _toDisplayString($setup.deviceInfo.bcvLastReleaseTime || '-'), 1)]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[4] || (_cache[4] = $event => $setup.toggleEdit('batCouValue'))
    }, {
      default: _withCtx(() => [_createTextVNode("编辑并下发")]),
      _: 1
    })), [[_directive_hasPermi, ['device:page:zlxf']]])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_el_input_number, {
      modelValue: $setup.editValues.batCouValue,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $setup.editValues.batCouValue = $event),
      min: 0,
      step: 1,
      controls: false,
      placeholder: "请输入电池容量",
      style: {
        "flex": "1"
      }
    }, null, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[6] || (_cache[6] = $event => $setup.handleWrite('batCouValue')),
      loading: $setup.writeLoading.batCouValue
    }, {
      default: _withCtx(() => [_createTextVNode("下发")]),
      _: 1
    }, 8, ["loading"])), [[_directive_hasPermi, ['device:page:zlxf']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      size: "small",
      onClick: _cache[7] || (_cache[7] = $event => $setup.cancelEdit('batCouValue'))
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    })), [[_directive_hasPermi, ['device:page:zlxf']]])], 64))])])])) : _createCommentVNode("", true), $setup.deviceInfo.actType == 1 ? (_openBlock(), _createElementBlock("tr", _hoisted_38, [_hoisted_39, _createElementVNode("td", null, [_createElementVNode("div", _hoisted_40, [!$setup.editMode.switchTimeout ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createElementVNode("span", _hoisted_41, _toDisplayString($setup.editValues.switchTimeout || '-'), 1), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[8] || (_cache[8] = $event => $setup.toggleEdit('switchTimeout'))
    }, {
      default: _withCtx(() => [_createTextVNode("编辑并下发")]),
      _: 1
    })), [[_directive_hasPermi, ['device:page:zlxf']]])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_el_input_number, {
      modelValue: $setup.editValues.switchTimeout,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $setup.editValues.switchTimeout = $event),
      min: 10,
      max: 60,
      step: 1,
      controls: false,
      placeholder: "请输入开关阀超时时间(10-60秒)",
      style: {
        "flex": "1"
      }
    }, null, 8, ["modelValue"]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      type: "primary",
      size: "small",
      onClick: _cache[10] || (_cache[10] = $event => $setup.handleWrite('switchTimeout')),
      loading: $setup.writeLoading.switchTimeout
    }, {
      default: _withCtx(() => [_createTextVNode("下发")]),
      _: 1
    }, 8, ["loading"])), [[_directive_hasPermi, ['device:page:zlxf']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
      size: "small",
      onClick: _cache[11] || (_cache[11] = $event => $setup.cancelEdit('switchTimeout'))
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    })), [[_directive_hasPermi, ['device:page:zlxf']]])], 64))])]), _hoisted_42])) : _createCommentVNode("", true)])]),
    _: 1
  })), [[_directive_loading, _ctx.tableLoading]])]);
}